"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalManager = exports.default = void 0;
var _Modal = _interopRequireDefault(require("react-overlays/Modal"));
var modalManager;
var useModalManager = exports.useModalManager = function useModalManager() {
  if (modalManager) {
    return modalManager;
  }
  modalManager = new _Modal.default.Manager({
    hideSiblingNodes: false,
    handleContainerOverflow: false
  });
  return modalManager;
};
var _default = exports.default = useModalManager;